import React from 'react';
import { useIntl } from 'react-intl';

// @mui/material components
import { Box, TextField, Typography } from '@mui/material';

import { isBlank, isValidCtaUrl } from './helpers';

/**
 * The text + url fields of one locale of a CTA link. The locale label (flag + language code)
 * is only shown on multi-locale organizations.
 */
export default function CtaLinkTranslationFields({ locale, translation, showLocaleLabel, onChangeField, onBlur }) {
    const intl = useIntl();
    const urlIsInvalid = !isBlank(translation.url) && !isValidCtaUrl(translation.url);

    return (
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 1 }}>
            {showLocaleLabel && (
                <Typography sx={{ width: 70, pt: 2, flexShrink: 0 }} title={locale.name}>
                    {locale.flag} {locale.code.split('_')[0]}
                </Typography>
            )}
            <TextField
                variant="standard"
                size="small"
                sx={{ flex: 1 }}
                label={intl.formatMessage({ id: 'category.form.ctaLinks.text' })}
                value={translation.text ?? ''}
                onChange={(event) => onChangeField('text', event.target.value)}
                onBlur={onBlur}
            />
            <TextField
                variant="standard"
                size="small"
                sx={{ flex: 2 }}
                label={intl.formatMessage({ id: 'category.form.ctaLinks.url' })}
                placeholder={intl.formatMessage({ id: 'category.form.ctaLinks.url.placeholder' })}
                value={translation.url ?? ''}
                error={urlIsInvalid}
                helperText={urlIsInvalid ? intl.formatMessage({ id: 'category.form.ctaLinks.url.invalid' }) : ' '}
                onChange={(event) => onChangeField('url', event.target.value)}
                onBlur={onBlur}
            />
        </Box>
    );
}
